import { useLazyFetch } from "hooks/fetch/useLazyFetch";

/**
 * Provides a callback function which can be used to post to the url passed in
 * @param url the url to post to
 * @param onCompleted callback that is fired when the put completes successfully
 * @param onError callback that is fired when the put errors
 * @returns {{putCallback: ((function(*=, *=): void)|*), loading: boolean, error: boolean}}
 *
 * loading - true when post is currently happening.
 *
 * error - true when an error has occured.
 *
 * putCallback - the put callback function, takes a body object and returns a promise which will contain json from the response.
 */
export function useFetchPut(url, onCompleted = undefined, onError = undefined) {
  const { loading, error, fetchCallback } = useLazyFetch(
    url,
    "PUT",
    onCompleted,
    onError
  );

  return { loading, error, putCallback: fetchCallback };
}
